import { useEffect } from "react";

const SITE = "Rimmon Farm";
const ORIGIN = "https://rimmonfarm.com";
const DEFAULT_DESC =
  "Farm-fresh Andhra mangoes, free-range eggs, A2 milk, wild honey & country chicken — direct from our farm. Order and pay online, delivered to your door.";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Updates document head per route. Indexable pages pass a title + description;
 * private pages (cart, checkout, account…) pass noindex to keep them out of Google.
 */
export default function Seo({ title, description = DEFAULT_DESC, path = "", noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Farm-Fresh Mangoes, Eggs, Milk & Poultry`;
    const url = `${ORIGIN}${path || "/"}`;

    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setCanonical(url);

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
  }, [title, description, path, noindex]);

  return null;
}
